

export const isTouchDevice = function(){
  if (typeof document == 'undefined')
    return false
  return 'ontouchstart' in document.documentElement
}